export const MAX_LENGTH_FILE_DOC_OUT = 5;
export const ALLOW_EXTENSION_FILE_DOC_OUT = ["pdf", "docx", "xlsx", "xls", "doc"];
